import {Product, SelectedFeature} from "../js/product";
import {EventVerteiler} from "./eventVerteiler";
import {LocalizerStatic} from "./Localizer";
import {sendPostRequest} from "./axiosFormWrapper";
import {ExtrapartInfo, PreisPreviewResponseClass} from "../js/databaseInterfaceClasses";
import {Logo, TextObject} from "../js/selectableObjects";


export type PreisAnzeigerNecessaryProductInfo = {
    ordertype:string,
    sport:string,
    produkt:string,
    features:SelectedFeature[],
    herstellerlogoEntfernt:boolean
}


export class PreisPreviewLoader{
    private readonly rechnungsland:string;
    private readonly globalRabattCode:string;
    private extraparts:string[]
    private product: PreisAnzeigerNecessaryProductInfo = {features: undefined, ordertype: undefined, produkt: undefined, sport: undefined, herstellerlogoEntfernt: undefined};

    private static PREIS_AUF_ANFRAGE_AMOUNT : 100;

    constructor(lieferland:string, globalRabattCode:string, logos:Logo[], texts:TextObject[]) {
        this.globalRabattCode = globalRabattCode;
        this.rechnungsland = lieferland;
        this.extraparts = this.getExtrapartsFuerPreisBerechnung(logos as ExtrapartInfo[], texts as ExtrapartInfo[]);
    }

    public setExtraParts(logos:ExtrapartInfo[], texts:ExtrapartInfo[] ) {
        this.extraparts = this.getExtrapartsFuerPreisBerechnung(logos, texts);
    }

    private getExtrapartsFuerPreisBerechnung(logos:ExtrapartInfo[], texts:ExtrapartInfo[]){
        const selObs = logos.concat(texts);
        return selObs.filter(obj => !!obj.hasTackleTwill === true).map(obj => obj.berechnungsFeature);
    }

    public setProductInfoFromOwayoProduct(p:Product, herstellerlogoEntfernt:boolean) {
        this.product = {
            features: p.selectedFeatures,
            ordertype: p.ordertype,
            produkt: p.produkt,
            sport: p.realsport,
            herstellerlogoEntfernt: herstellerlogoEntfernt
        };
    }

    public setProductInfo(ordertype:string, product:string, sport:string, features:SelectedFeature[], herstellerlogoEntfernt:boolean) {
        this.product = {
            features: features,
            ordertype: ordertype,
            produkt: product,
            sport: sport,
            herstellerlogoEntfernt:herstellerlogoEntfernt
        };
    }

    private getPreisPreviewDataObject(amount:number) {
        return {
            amount: amount,
            orderType: this.product.ordertype,
            sport: this.product.sport,
            produkt: this.product.produkt,
            features: JSON.stringify(this.product.features),
            rabatt: this.globalRabattCode,
            land:this.rechnungsland,
            extraparts: JSON.stringify(this.extraparts),
            herstellerlogosEntfernt: this.product.herstellerlogoEntfernt
        }
    }

    private static preisPreviewSuccessHandler(data:PreisPreviewResponseClass, eventToFire:string) {
        EventVerteiler.broadcast(eventToFire, {
            preis: data.preis,
            originalPreis: data.originalPreis,
            symbol: data.symbol,
            isEUStaat: data.isEUStaat,
            inklusiveMwSt: data.inklusiveMwSt,
            isStandardPriceList:data.isStandardPriceList,
            formattedEndPreis:LocalizerStatic.localizeCurrency(data.symbol, data.preis)
        });
    }

    private static errorHandler() {
        // globalsObject.errorHandler.handleErrorTranslateMessage(
        //     "ajaxFail",
        //     "getPreisPreview",
        //     "konf_error_getPreisPreview"
        // )
    }

    public getPreis(amount:number, eventToFire:string) {

        if (amount > PreisPreviewLoader.PREIS_AUF_ANFRAGE_AMOUNT) {
            EventVerteiler.broadcast(eventToFire, {
                preis: "PREIS_ANFRAGE",
                originalPreis: "PREIS_ANFRAGE",
                symbol: ""
            });
            return;
        }
        this.getPriceFromServer(amount, eventToFire);
    }

    public getPriceFromServerAsPromise(amount:number) {
        if(amount > PreisPreviewLoader.PREIS_AUF_ANFRAGE_AMOUNT) {
            console.log("amount war zu gross: "+amount)
        }

        return new Promise<PreisPreviewResponseClass>((resolve, reject) => {
            sendPostRequest("/konfigurator_php/actionmodul/getPreisPreview.php", this.getPreisPreviewDataObject(amount))
                .then(response=>resolve(response.data)).catch(reject)
        })

    }

    public static getPreisZusatzTextID(lieferlandIsEUStaat: boolean, inklusiveMwSt: boolean) {
        return lieferlandIsEUStaat || inklusiveMwSt ? "konfi_inklMWST" : "konfi_exklMWST";
    }

    public getPriceFromServer(amount: number, eventToFire:string) {
        this.getPriceFromServerAsPromise(amount).then(response=>PreisPreviewLoader.preisPreviewSuccessHandler(response, eventToFire)).catch(PreisPreviewLoader.errorHandler)
    }
}
